
import { Vue, Component } from 'vue-property-decorator'

import {VModel} from "vue-property-decorator";
import {IOnOffHandlers} from "bonomo";
import {namespace} from "vuex-class";
import {IErrors} from "@/model/IErrors";
import {UrlHelper} from "@/helpers/UrlHelper";

const lockerCompanyModule = namespace("lockerCompanyModule");

@Component({})
export default class LCCreateLockerCompanyDialog extends Vue {
  @lockerCompanyModule.Getter('errors')
  private errors!: IErrors;

  @lockerCompanyModule.Action('createLockerCompany')
  private createLockerCompany!: ({ slug, description }: { slug: string, description: string}) => void

  @lockerCompanyModule.Action('cleanErrors')
  private cleanErrors!: () => void

  @VModel()
  private dialogShowing!: boolean;

  private slug: string = '';
  private description: string = '';

  private submitting: boolean = false;
  private subscribes: IOnOffHandlers = {};

  private created() {
    this.subscribes = this.$ons({
      'backend.call.OK.lockerCompanyCreated': this.newLockerCompanyCreated,
      'backend.call.KO.lockerCompanyCreated': this.newLockercompanyFailed,
    });
  }

  private beforeDestroy() {
    this.$offs(this.subscribes);
  }

  private onSubmit() {
    this.submitting = true;
    this.createLockerCompany({slug: this.slug, description: this.description})
  }

  private newLockerCompanyCreated() {
    this.submitting = false;
    this.dialogShowing = false;
    this.slug = '';
    this.description = '';
    this.cleanErrors();
  }

  private newLockercompanyFailed() {
    this.submitting = false;
  }

  private updateSlug() {
    this.slug = UrlHelper.slugGenerator(this.description)
  }

  private onClose() {
    this.dialogShowing = false;
  }

}

